module.exports = __webpack_public_path__ + "media/images/icons/friend-ce5c9491ff1d2acfa0e3daafeaf79ea5.svg";